import { createAsyncThunk } from '@reduxjs/toolkit';
import deviceApi from '~/apis/device';
import { Device, ICheckParams, IDeleteDevice } from '~/utils/interface/device';

export type GetDevicesParams = {
  username: string;
  provinceId?: string;
  wardId?: string;
  status?: number | string;
  from?: string;
  to?: string;
  search?: string;
  pageIndex?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
};

export const handleGetDevices = createAsyncThunk<any, GetDevicesParams>(
  'DEVICE_GET_DEVICES',
  async (params: GetDevicesParams, { rejectWithValue }) => {
    try {
      const res = await deviceApi.getList(params);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCheckDevice = createAsyncThunk<Device, ICheckParams>(
  'DEVICE_CHECK_DEVICE',
  async (params: ICheckParams, { rejectWithValue }) => {
    try {
      const res = await deviceApi.checkDevice(params);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateDevice = createAsyncThunk<Device, Device>(
  'DEVICE_UPDATE_DEVICE',
  async (data: Device, { rejectWithValue }) => {
    try {
      const res = await deviceApi.updateDevice(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleDeleteDevice = createAsyncThunk<void, IDeleteDevice>(
  'DEVICE_DELETE_DEVICE',
  async (data: IDeleteDevice, { rejectWithValue }) => {
    try {
      await deviceApi.deleteDevice(data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
